import {profile} from 'constants/url';
import useDelete from 'components/hooks/useDelete';
import {DeletingOptions} from 'components/grid-dx/types';

function useDeleteProfile() {
  const deleteProfile = useDelete(profile);
  return (deletingOptions: DeletingOptions) => deleteProfile(deletingOptions);
}

export default useDeleteProfile;
